<template>
  <CDataTable
      striped
      :header="false"
      :items="files"
      :fields="fields"
      class="custom-table custom-table--clean custom-table--uploader"
      :class="{'is-failed': failed, 'no-results': files.length === 0}"
  >
    <template #name="{item}">
      <td>
        <template v-if="item.file.pending">
          <span class="p-uploader__file-name" :title="item.name">{{ item.name|truncate(20, '...') }}</span>
        </template>
        <template v-else>
          <Preview :view-file="false"
                   show-file-attrs
                   :truncate-char="20"
                   icon-size="compact"
                   :file="item.file"
                   @loadImage="$emit('loadImage',$event)"/>
        </template>
      </td>
    </template>
    <template #motivation="{item}">
      <td>
         <CAlert :color="item.file.pending ? 'warning': 'danger'"
                 class="alert-uploader m-0"
                 :class="[item.file.pending ? 'alert-uploader--warning' : 'alert-uploader--danger']"
                 v-if="item.motivation">
           <div class="d-flex align-items-center">
             <CIcon name="cipTriangleWarning" size="lg" class="mr-2"/>
             <div class="motivation-text" :title="item.motivation">{{ item.motivation }}</div>
            </div>
         </CAlert>
      </td>
    </template>
    <template #tags="{item}">
      <td v-if="item.tags || item.picaCode">
        <CBadge class="badge-outline mr-2" shape="pill" color="primary" v-for="tag in item.tags" :key="tag">
          {{ tag }}
        </CBadge>

        <CBadge v-if="item.picaCode" class="badge-outline" shape="pill" color="success">
          PICA CODE: {{ item.picaCode }}
        </CBadge>
      </td>
    </template>
    <template #delete="{item}">
      <td>
        <CButtonClose class="list-item-closer mr-1" @click.stop="onDelete(item)">
          <CIcon name="cipClose" size="custom-size" width="15" />
        </CButtonClose>
      </td>
    </template>
  </CDataTable>

</template>

<script>
import Preview from "@/domain/uploader/components/Preview.vue";

export default {
  name: "NotificationTable",
  components: {Preview},
  props: {
    rows: {
      type: Array,
      required: true
    },
    failed: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    files() {
      return this.rows.map((file) => {
        return {
          md5: file.md5,
          name: file.name,
          size: file.size,
          tags: file.tags,
          picaCode: file.picaCode,
          resolution: file.resolution || '',
          motivation: file.motivation,
          human_size: file.human_size,
          file: file,
        }
      })
    },
    fields() {
      let fields = []
      fields.push({key: 'name', label: this.$pgettext('uploader.to_upload', 'Name')})

      if (this.failed)
        fields.push({key: 'motivation', label: this.$pgettext('uploader.to_upload', 'Motivation')})

      if (!this.failed)
        fields.push({key: 'tags', label: this.$pgettext('uploader.to_upload', 'Tags')})
      fields.push({key: 'delete', label: ''})

      return fields
    }
  },
  emits: ['retry', 'delete', 'loadImage'],
  methods: {
    onRetry(file) {
      this.$emit('retry', [file])
    },
    onDelete(file) {
      this.$emit('delete', [file])
    }
  }
}
</script>

<style scoped>

</style>